import React, { useMemo } from 'react';

/**
 * Configuration Table is a helper component that displays the configuration of the device in use.
 * It extracts all the necessary information from the description to show it properly.
 * customName is pre-resolved by ThumbnailList and passed as a prop.
 */

const ConfigurationTable = ({ description, customName }) => {
  const parsedConfig = useMemo(() => {
    let planningName = '';
    let deviceType = '';
    let deviceSize = '';
    let tspSite = '';

    if (description) {
      // Normalize: remove extra spaces around dashes and remove duplicate dashes
      const normalized = description
        .replace(/\s*-\s*/g, '-') // Remove spaces around dashes
        .replace(/-+/g, '-') // Remove duplicate dashes
        .replace(/^-|-$/g, ''); // Remove leading/trailing dashes

      // Format: {NAME}-{TYPE_DEVICE}-{SIZE}-{TSP}
      const deviceTypePattern = /-(AML|FLX)-/g;
      let matches = [...normalized.matchAll(deviceTypePattern)];

      if (matches.length > 0) {
        // Use the last match to handle cases like "test-AML-AML"
        const match = matches[matches.length - 1];
        const typeStartIndex = match.index;
        const typeEndIndex = typeStartIndex + match[0].length;

        planningName = normalized.substring(0, typeStartIndex).trim();

        const deviceTypeMap = {
          AML: 'AMULET',
          FLX: 'FLX',
        };
        deviceType = deviceTypeMap[match[1]] || match[1];

        // Get the remaining part after the device type
        const remainingPart = normalized.substring(typeEndIndex);
        const remainingParts = remainingPart.split('-').filter(p => p.trim());

        deviceSize = remainingParts[0] || '';
        tspSite = remainingParts[1] || '';
      }
    }

    return {
      planningName,
      deviceType,
      deviceSize,
      tspSite,
    };
  }, [description]);

  const displayName = customName || parsedConfig.planningName;

  return (
    <div className="flex w-full flex-col items-center space-y-3 text-black">
      {/* Custom Name Badge - Pre-resolved from parent */}
      {displayName && (
        <div className="px-4 py-1 text-sm font-bold text-gray-900">{displayName}</div>
      )}

      {/* Configuration Table - Centered */}
      <div className="flex w-full justify-center">
        <div className="grid grid-cols-3 gap-8">
          {/* Type */}
          <div className="flex flex-col items-center justify-center">
            <span className="text-sm font-bold text-gray-900">Type</span>
            <span className="text-sm font-bold text-gray-900">{parsedConfig.deviceType || '-'}</span>
          </div>

          {/* Size */}
          <div className="flex flex-col items-center justify-center">
            <span className="text-sm font-bold text-gray-900">Size</span>
            <span className="text-sm font-bold text-gray-900">{parsedConfig.deviceSize || '-'}</span>
          </div>

          {/* TSP Site */}
          <div className="flex flex-col items-center justify-center">
            <span className="text-sm font-bold text-gray-900">TSP Site</span>
            <span className="text-sm font-bold text-gray-900">{parsedConfig.tspSite || '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationTable;
